import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'app/hooks'

import { useHomeRouteParams } from 'features/home/hooks'
import { subscriptionsHistorySelector } from 'features/home/selectors'
import SubscriptionHistoryTable from '../SubscriptionHistoryTable'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { fetchSubscriptionHistoryThunk } from './slice'
import SubscriptionPlanDetails from '../SubscriptionPlanDetails'

function SubscriptionHistory() {
  const dispatch = useAppDispatch()
  const { homeId } = useHomeRouteParams()
  const data = useAppSelector(subscriptionsHistorySelector)
  const rootDomainId = useAppSelector(currentRootDomainIdSelector)

  useEffect(() => {
    homeId &&
      rootDomainId &&
      dispatch(fetchSubscriptionHistoryThunk(rootDomainId, homeId))
  }, [dispatch, homeId, rootDomainId])

  return (
    <>
      <SubscriptionPlanDetails isHomeDashboard={false} hasShowMore />
      <SubscriptionHistoryTable data={data} />
    </>
  )
}
export default SubscriptionHistory
